import { createAction, props } from '@ngrx/store';

import { EntityConnectionCoreFragment } from 'generated/graphql';

import { EntityConnectionTableStateKeyParams } from './entity-connection-table-key';

export const SET_EC_TABLE_SHOW_INACTIVE = createAction(
  '[EntityConnectionTable] SET_SHOW_INACTIVE',
  props<{ payload: { key: EntityConnectionTableStateKeyParams; value: { includeInactive: boolean } } }>()
);

/**
 * Triggered whenever there is a change to entity connections.
 * Used by other listeners to trigger refeching on tangentially related
 * objects. e.g. Tasks, EntityConnectionCounts
 *
 */
export const ENTITY_CONNECTIONS_CHANGED = createAction(
  '[EntityConnection] ENTITY_CONNECTIONS_CHANGED',
  props<{ payload: { entityConnection: EntityConnectionCoreFragment } }>()
);
